import { useContext, useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import useAuth from '../hooks/use-auth'
import { AppStateContext, AuthContext } from '../contexts'
import { isSuiteSsoRedirectMode } from '../sso/sso-flags'
import { useSuiteAuth } from '../sso/contexts/suite-auth.context'
import { logInfo, logWarn } from '../sso/utils/sso-logger'

const RouteGuard = () => {
  const user = useAuth()
  const { removeAuth } = useContext(AuthContext)
  const { setCurrentBanksData, updateBanksBalancesDataLoadedStatus } = useContext(AppStateContext)
  const { status: suiteAuthStatus } = useSuiteAuth()

  const suiteSessionActive =
    isSuiteSsoRedirectMode() && (suiteAuthStatus === 'authenticated' || suiteAuthStatus === 'hydrating')

  useEffect(() => {
    logInfo('RouteGuard — token validation', {
      userType: user === 'invalid-token' ? 'invalid-token' : user ? 'valid' : 'pending',
      suiteSessionActive
    })
  }, [user, suiteSessionActive])

  if (suiteSessionActive) {
    return <Outlet />
  }

  if (user === 'invalid-token') {
    logWarn('RouteGuard — invalid Pay JWT (role mismatch), clearing session → /login')
    removeAuth?.()
    setCurrentBanksData?.([])
    updateBanksBalancesDataLoadedStatus?.(false)

    return (
      <Navigate
        to="/login"
        replace
      />
    )
  }

  return <Outlet />
}

export default RouteGuard
